// @flow
import * as React from 'react';
import Logging from '@ta/common.logging';
import { type LogInteraction } from '@ta/tracking.interactions';

const defaultNoopTracker = DEBUG
  ? () => {
      Logging.info(
        `Attempting to track interactions without a MentionsInteractionContext. This is a no-op`,
      );
      return Promise.resolve();
    }
  : null;

type MentionsInteractionContextValue = LogInteraction | null;

const MentionsInteractionContext = React.createContext<MentionsInteractionContextValue>(
  defaultNoopTracker,
);

export default MentionsInteractionContext;
